import React, { PureComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import { Dispatch, Action } from "redux";
import { attempt, get, isEmpty } from "lodash";
import tvgConf from "@tvg/conf";
import calculateFeatureOverride from "@tvg/utils/featuresUtils";

import {
  failFeaturesRequest,
  failMessagesRequest,
  successFeaturesRequest,
  successMessagesRequest
} from "../actions/capi";
import {
  Feature,
  FeatureToggles,
  MapFeatureToggles,
  Messages
} from "../actions/types";
import MicroApp from "./components/MicroApp";
import { AppState } from "../reducers";

interface Props {
  dispatch: Dispatch<Action>;
  features: Feature[];
  featureToggles: MapFeatureToggles;
  messages: Messages;
}

export class Main extends PureComponent<Props> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tvg: any = tvgConf();

  componentDidMount() {
    if (typeof window !== "undefined") {
      if (!isEmpty(this.props.features)) {
        const featureToggles: MapFeatureToggles = {};
        let featureOverrides = this.getFeaturesOverrides() || {};
        const hasFeaturesOverrides = !!this.getFeaturesOverrides();

        this.props.features.forEach((toggle: Feature) => {
          let { enabled } = toggle;
          featureOverrides = calculateFeatureOverride(
            hasFeaturesOverrides,
            featureOverrides,
            toggle
          );
          if (get(featureOverrides, toggle.name)) {
            // eslint-disable-next-line prefer-destructuring
            enabled = featureOverrides[toggle.name].enabled;
          }

          featureToggles[toggle.name] = enabled;
        });

        if (typeof window !== "undefined" && !isEmpty(featureOverrides)) {
          this.setFeaturesOverrides(featureOverrides);
        }
        this.props.dispatch(successFeaturesRequest(featureToggles));
      } else {
        this.getFeatures();
      }

      this.getMessages();
    }
  }

  getFeaturesOverrides = () =>
    attempt(
      // @ts-ignore
      () => JSON.parse(window.localStorage.getItem("featureOverrides")),
      false
    );

  setFeaturesOverrides = (features: Feature) =>
    attempt(() =>
      window.localStorage.setItem("featureOverrides", JSON.stringify(features))
    );

  getFeatures = () =>
    typeof window !== "undefined" &&
    this.tvg
      .getFeatures()
      .then((response: FeatureToggles | false) => {
        const featureToggles: MapFeatureToggles = {};
        let featureOverrides = this.getFeaturesOverrides() || {};
        const hasFeaturesOverrides = !!this.getFeaturesOverrides();

        if (response && Array.isArray(response.featureToggles)) {
          response.featureToggles.forEach((toggle: Feature) => {
            let { enabled } = toggle;
            featureOverrides = calculateFeatureOverride(
              hasFeaturesOverrides,
              featureOverrides,
              toggle
            );
            if (get(featureOverrides, toggle.name)) {
              // eslint-disable-next-line prefer-destructuring
              enabled = featureOverrides[toggle.name].enabled;
            }

            featureToggles[toggle.name] = enabled;
          });
        }

        if (!isEmpty(featureOverrides)) {
          this.setFeaturesOverrides(featureOverrides);
        }

        this.props.dispatch(successFeaturesRequest(featureToggles));
      })
      .catch((err: Error) => this.props.dispatch(failFeaturesRequest(err)));

  getMessages = () => {
    const messageNamespaces = ["Registration", "Login", "InformationalPages"];

    return this.tvg
      .getMessages(messageNamespaces)
      .then((response: Messages) =>
        this.props.dispatch(successMessagesRequest(response))
      )
      .catch((err: Error) => this.props.dispatch(failMessagesRequest(err)));
  };

  render() {
    return (
      <>
        <Routes>
          <Route path="/registration" element={<MicroApp />} />
        </Routes>
      </>
    );
  }
}

export default connect((store: AppState) => ({
  featureToggles: get(store, "capi.featureToggles"),
  features: get(store, "capi.features"),
  messages: store.capi.messages
}))(Main);
